import { render, staticRenderFns } from "./MeasureCreate.vue?vue&type=template&id=010f000e&scoped=true&"
import script from "./MeasureCreate.vue?vue&type=script&lang=js&"
export * from "./MeasureCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010f000e",
  null
  
)

export default component.exports